import SessionStore from '@/State/SessionStore'
import { createTRPCProxyClient, httpBatchLink } from '@trpc/client'
import type { AppRouter } from '../../../server_node/src/trpc/router'
import { clerk } from '../App'
import { usingNewLogin } from '../State/Permissions/HasPermissions'
import posthog from 'posthog-js'

export const trpc = createTRPCProxyClient<AppRouter>({
    links: [
        httpBatchLink({
            url: `${process.env.REACT_APP_NODE_SERVER_URL}/trpc`,
            async headers() {
                const headers: Record<string, string> = {}

                // if (usingNewLogin()) {
                //     const token = await clerk?.session?.getToken?.({
                //         template: 'coincraft',
                //     })
                //     headers.Authorization = token ? `Bearer ${token}` : ''
                // } else {
                // Add legacy auth headers
                if (SessionStore.userId)
                    headers['x-user-id'] = SessionStore.userId
                if (SessionStore.organisationId)
                    headers['x-org-id'] = SessionStore.organisationId
                // }

                // Add PostHog session info for server-side event tracking
                try {
                    const sessionId = posthog.get_session_id()
                    const distinctId = posthog.get_distinct_id()
                    if (sessionId) headers['x-posthog-session-id'] = sessionId
                    if (distinctId)
                        headers['x-posthog-distinct-id'] = distinctId
                } catch (error) {
                    // PostHog might not be initialized yet, that's ok
                    console.debug(
                        'PostHog session info not available:',
                        error.message
                    )
                }

                return headers
            },
            fetch(url, options) {
                return fetch(url, {
                    ...options,
                    credentials: 'include',
                })
            },
        }),
    ],
})
